import { EventEmitter } from "@Front/Services/EventEmitter";

class WindowStore {
	private static _instance: WindowStore | null = null;
	private _event: EventEmitter | null = null;

	private get event(): EventEmitter {
		if (!this._event) {
			this._event = new EventEmitter();
		}
		return this._event;
	}

	private constructor() {
		// Only initialize events on client-side (not during SSR/build)
		if (typeof window !== "undefined") {
			this.iniEvents();
		}
	}

	public static getInstance(): WindowStore {
		if (!WindowStore._instance) {
			WindowStore._instance = new WindowStore();
		}
		return WindowStore._instance;
	}

	public onScrollYDirectionChange(callback: (scrollYDifference: number) => void): () => void {
		this.event.on("scrollYDirectionChange", callback);
		return () => {
			this.event.off("scrollYDirectionChange", callback);
		};
	}

	public onResize(callback: (window: Window) => void): () => void {
		this.event.on("resize", callback);
		return () => {
			this.event.off("resize", callback);
		};
	}

	public onClick(callback: (e: MouseEvent) => void): () => void {
		this.event.on("click", callback);
		return (): void => {
			this.event.off("click", callback);
		};
	}

	private iniEvents(): void {
		if (typeof window === "undefined" || typeof document === "undefined") return;
		window.addEventListener("scroll", () => this.scrollYHandler());
		window.addEventListener("resize", () => this.resizeHandler());
		document.addEventListener("click", (event: MouseEvent) => this.clickHandler(event), true);
	}

	private clickHandler(e: MouseEvent): void {
		this.event.emit("click", e);
	}

	private scrollYHandler = (() => {
		let previousY = typeof window !== "undefined" ? window.scrollY : 0;
		let snapShotY = previousY;
		let previousYDirection = 1;
		return (): void => {
			if (typeof window === "undefined") return;
			const scrollYDirection = window.scrollY - previousY > 0 ? 1 : -1;
			if (previousYDirection !== scrollYDirection) {
				snapShotY = window.scrollY;
			}

			this.event.emit("scrollYDirectionChange", snapShotY - window.scrollY);
			previousY = window.scrollY;
			previousYDirection = scrollYDirection;
		};
	})();

	private resizeHandler(): void {
		if (typeof window === "undefined") return;
		this.event.emit("resize", window);
	}
}

// Export named only - no default export to avoid Webpack initialization order issues
export { WindowStore };
